import axios from "axios";
import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell } from "recharts";
import { datearray } from "../Date";
import { BASE_URL } from "../../config/axios";
import { handleAllError, handleErrorToast } from "../CustomFunctions";





const AttendanceArc = () => {



    const [selectedOption, setSelectedOption] = useState('today');

    const [attendancearc, setAttendancearc] = useState({});

    const dateData = new Date();
    const year = dateData.getFullYear();
    const month = dateData.getMonth() + 1;
    const day = dateData.getDate();
    const yday = dateData.getDate() - 1;

    const today = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const yesterday = `${year}-${month.toString().padStart(2, "0")}-${yday
        .toString()
        .padStart(2, "0")}`;


    const getJobapppdata = async (selectedOption) => {
        try {
            const res = await axios.get(
                selectedOption === "today"
                    // ? `${BASE_URL}/wfm/attendancefilterbyEmpByMonthStats/${sessionStorage.getItem('emp_code')}/${datearray[1]}/${datearray[0]}/`
                    // : `${BASE_URL}/wfm/attendancefilterbyEmpByYearStats/${sessionStorage.getItem('emp_code')}/${datearray[0]}/`

                    ? `${BASE_URL}/wfm/attendancecountbysubcompanycount/${today}/${sessionStorage.getItem('company_id')}/`
                    : `${BASE_URL}/wfm/attendancecountbysubcompanycount/${yesterday}/${sessionStorage.getItem('company_id')}/`
                // ? `${BASE_URL}/wfm/attendancecount/${today}/`
                // : `${BASE_URL}/wfm/attendancecount/${yesterday}/`
            );

            setAttendancearc(res.data);
        } catch (err) {
            // alert(err.message);
            handleAllError(err)
        }
    };

    useEffect(() => {
        getJobapppdata(selectedOption);
    }, [selectedOption]);

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };


    const total_count = attendancearc.present_count + attendancearc.absent_count + attendancearc.leave_count + attendancearc.ouduty_count


    const data = [
        { name: "Group A", value: attendancearc.absent_count },
        { name: "Group B", value: total_count - attendancearc.absent_count },
    ];


    const leavepercentage = Math.floor(attendancearc.absent_count / total_count * 100)

    const dataa = [
        { name: "Group A", value: (attendancearc.leave_count) },
        { name: "Group B", value: total_count - (attendancearc.leave_count) },
    ];


    const latepercentage = Math.floor((attendancearc.leave_count) / total_count * 100)


    const dataaa = [
        { name: "Group A", value: attendancearc.present_count + attendancearc.ouduty_count },
        { name: "Group B", value: total_count - (attendancearc.present_count + attendancearc.ouduty_count) },
    ];


    const presentpercentage = Math.floor((attendancearc.present_count + attendancearc.ouduty_count) / total_count * 100)

    const AbsentCOLOURS = ["#FF747C", "#EFEFEF"];

    const LeaveCOLOURS = ["#F7BA1E", "#EFEFEF"];

    const PresentCOLORS = ["#06AD06", "#EFEFEF"];


    return (
        <>
            <div className="attendnace-piechart-dashboard">
                <div>
                    <div className="hrdb-piechart-dashboard-heading">
                        <div className="db2-card-title">Attendance</div>
                        <div className="radialchart-dropdown">
                            <select style={{ border: "1px solid #E2E8F0", borderRadius: 8, padding: "5px 10px", fontSize: 12, fontWeight: 500, color: "#334155", background: "#fff", cursor: "pointer", outline: "none" }} onChange={handleChange} value={selectedOption}>
                                <option value="today">Today</option>
                                <option value="yesterday">Yesterday</option>
                            </select>
                        </div>
                    </div>
                    <div className="piechart-flex">

                        <div className="hr-piechart-dashboard">
                            <div>
                                <PieChart width={190} height={150}>
                                    <Pie
                                        data={dataaa}
                                        cx={90}
                                        cy={120}
                                        startAngle={180}
                                        endAngle={0}
                                        innerRadius={70}
                                        cornerRadius={20}
                                        outerRadius={90}
                                        fill="#8884d8"
                                        paddingAngle={3}
                                        dataKey="value"
                                    >
                                        {dataaa.map((entry, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={PresentCOLORS[index % PresentCOLORS.length]}
                                            />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </div>
                            <div className="hr-piechart-heading">
                                <div
                                    className="hr-piechart-dot"
                                    style={{ backgroundColor: "#06AD06" }}
                                ></div>
                                <div className="hr-piechart-subheading   font-weight400  font-size-label">Present Employee</div>
                            </div>
                            <div className="piechart-percentage font-weight700">{presentpercentage} % ({attendancearc.present_count + attendancearc.ouduty_count})</div>
                        </div>


                        <div className="hr-piechart-dashboard">
                            <div>
                                <PieChart width={190} height={150}>
                                    <Pie
                                        data={dataa}
                                        cx={90}
                                        cy={120}
                                        startAngle={180}
                                        endAngle={0}
                                        innerRadius={70}
                                        cornerRadius={20}
                                        outerRadius={90}
                                        fill="#8884d8"
                                        paddingAngle={3}
                                        dataKey="value"
                                    >
                                        {dataa.map((entry, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={LeaveCOLOURS[index % LeaveCOLOURS.length]}
                                            />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </div>
                            <div className="hr-piechart-heading">
                                <div
                                    className="hr-piechart-dot"
                                    style={{ backgroundColor: "#F7BA1E" }}
                                ></div>
                                <div className="hr-piechart-subheading   font-weight400  font-size-label">Leave Employee</div>
                            </div>
                            <div className="piechart-percentage font-weight700">{latepercentage} % ({attendancearc.leave_count})</div>
                        </div>



                        <div className="hr-piechart-dashboard">
                            <div>
                                <PieChart width={190} height={150}>
                                    <Pie
                                        data={data}
                                        cx={90}
                                        cy={120}
                                        startAngle={180}
                                        endAngle={0}
                                        innerRadius={70}
                                        cornerRadius={20}
                                        outerRadius={90}
                                        fill="#8884d8"
                                        paddingAngle={3}
                                        dataKey="value"
                                    >
                                        {data.map((entry, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={AbsentCOLOURS[index % AbsentCOLOURS.length]}
                                            />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </div>
                            <div className="hr-piechart-heading">
                                <div
                                    className="hr-piechart-dot"
                                    style={{ backgroundColor: "#FF747C" }}
                                ></div>
                                <div className="hr-piechart-subheading   font-weight400  font-size-label">Absent Employee</div>
                            </div>
                            <div className="piechart-percentage font-weight700">{leavepercentage} % ({attendancearc.absent_count})</div>
                        </div>

                    </div >
                </div >
            </div >
        </>
    );
};

export default AttendanceArc;
